import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import {NgForm} from '@angular/forms';
import * as firebase from "firebase/app";

// Add the Firebase services that you want to use
import "firebase/auth";
import "firebase/database";


@Component({
  selector: 'app-editfaculty',
  templateUrl: './editfaculty.component.html',
  styleUrls: ['./editfaculty.component.css']
})
export class EditfacultyComponent implements OnInit {
info:any;
name:any;
pictureurl:any;
description:any;
  constructor(private route:ActivatedRoute) { }

  ngOnInit() {

    this.info = this.route.snapshot.data['editfaculty'];

    this.name = this.info.name;
    this.pictureurl = this.info.pictureurl;
    let data = this.info.description;
    document.getElementById("editor").innerHTML = data;
     this.description = data.replace( '&', '&amp;' );
  }
  save(faculty:NgForm){
    let value = faculty.value;
    let descript = document.getElementById('display').innerHTML;
    let pictureurlsi = document.getElementById('pictureurl').innerHTML;
    console.log(pictureurlsi);
    if(pictureurlsi != ""){
      let pictureurls = JSON.parse(pictureurlsi) || this.pictureurl;
      let pictureurl = pictureurls.image || this.pictureurl;
}
let pictureurl =  this.pictureurl;


    let desc = {desc:descript, pictureurl: pictureurl};
    let p ={...desc, ...faculty.value}
    console.log(p);
    let id = p.name;
    let db= firebase.database();
    db.ref('faculties/'+id).set({pictureurl: p.pictureurl,
    description: p.desc, name:id}, function(error){
      if(error){
        alert(error)
      }else{alert('data saved successfully')}
    })
  }

}
